import { render, staticRenderFns } from "./easyTable.vue?vue&type=template&id=063abec0&scoped=true"
import script from "./easyTable.vue?vue&type=script&lang=js"
export * from "./easyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063abec0",
  null
  
)

export default component.exports